import { render } from "./AppSideMenu.vue?vue&type=template&id=0b443a76&scoped=true&ts=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=ts"
export * from "./AppSideMenu.vue?vue&type=script&lang=ts"

import "./AppSideMenu.vue?vue&type=style&index=0&id=0b443a76&scoped=true&lang=css"

import exportComponent from "/home/runner/work/houseme-UI/houseme-UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b443a76"]])

export default __exports__